var _ellipse, _ellipse2, _ellipse3, _path, _path2, _circle, _circle2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSigns(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 260",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 200,
    rx: 85,
    ry: 18,
    stroke: "#38bdf8",
    strokeOpacity: 0.15,
    strokeWidth: 1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 130,
    rx: 95,
    ry: 75,
    stroke: "#fafcfb",
    strokeOpacity: 0.12,
    strokeWidth: 1
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 115,
    rx: 70,
    ry: 45,
    stroke: "#38bdf8",
    strokeOpacity: 0.25,
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145 195 Q145 120 200 105 Q255 120 255 195 Z",
    stroke: "#fafcfb",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M175 150 Q200 165 225 150",
    stroke: "#fafcfb",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 138,
    r: 3,
    fill: "#fafcfb",
    opacity: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 215,
    cy: 138,
    r: 3,
    fill: "#fafcfb",
    opacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90 80 Q110 60 130 80 Q110 100 90 80",
    stroke: "#fbbf24",
    strokeWidth: 1.5,
    strokeOpacity: 0.55
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M270 75 Q290 55 310 75 Q290 95 270 75",
    stroke: "#fbbf24",
    strokeWidth: 1.5,
    strokeOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75 145 Q95 125 115 145",
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    strokeOpacity: 0.4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M285 140 Q305 120 325 140",
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    strokeOpacity: 0.4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M110 55 L108 65 M130 50 L128 60 M290 52 L288 62",
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    strokeOpacity: 0.45,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigns);
export default __webpack_public_path__ + "static/media/signs.c9cd77df25b6d8bf7925d7cac3d57634.svg";
export { ForwardRef as ReactComponent };